import { get, capturedGet, capturedPost, capturedPut, capturedRemove } from '../../http';

const state = {};
const getters = {};
const mutations = {};
const actions = {
  async removeCreation (context, { platform, id }) {
    return await capturedRemove(`/${platform}/creative/${id}`)
  },
  async batchStartAndStopCreation (context, { platform, isStart, ids }) {
    return capturedPost(`/${platform}/creative/${isStart ? 'batchstart' : 'batchstop'}`, { ids })
  },
  async getCreations (context, { platform, params }) {
    return await capturedGet(`/${platform}/creative`, params)
  },
  async getSelectData (context, { platform }) {
    return await capturedGet(`/${platform}/creative/selectlist`)
  },
  async validateCreativeName (context, { platform, value }) {
    return await capturedGet(`/${platform}/creative/is-repeated`, { creative_name: value })
  },
  async getAdUsers (context, { platform }) {
    return await capturedGet(`/${platform}/ads/ad/adselect`)
  },
  async getAdGroupsByAdUserId (context, { platform, value }) {
    return await capturedGet(`/${platform}/global-order/get-orders-for-ad${value ? '/' + value : ''}`)
  },
  async getPlansByAdGroupId (context, { platform, value }) {
    return await capturedGet(`/${platform}/global/get-ads-for-creative/${value}`)
  },
  async checkAdUrl (context, { platform, type, url }) {
    return await capturedGet(`/${platform}/creative/handle_url`, { conversion_monitor_type: type, url })
  },
  async uploadPicture (context, { platform, isMaterial, formData }) {
    return await capturedPost(isMaterial ? `/${platform}/creative/materials-upload` : `/${platform}/global/ads/upload`, formData, { 'Content-Type': 'multipart/form-data' })
  },
  async uploadVideo (context, { platform, formData }) {
    return await capturedPost(`/${platform}/creative/upload-video`, formData, { 'Content-Type': 'multipart/form-data' })
  },
  async uploadMaterialCut (context, { platform, formData }) {
    return await capturedPost(`/${platform}/creative/materials-upload-cut`, formData, { 'Content-Type': 'multipart/form-data' })
  },
  async getMaterialSizes (context, { platform, id }) {
    return await capturedGet(`/${platform}/global/get-place-scale/${id}`)
  },
  async handleOnRemove (context, { platform, ids }) {
    return await capturedGet(`/${platform}/creative/delplacematerials`, { ids })
  },
  async submitForm (context, { platform, type, id, formData }) {
    const requestMethod = type === 'edit' ? capturedPut : capturedPost
    return await requestMethod(`/${platform}/creative${type === 'edit' ? '/' + id : ''}`, formData)
  },
  async getFirstAppStoreOptions({ state, commit }, { data } = {}) {
    const response = await get('/interface/item/first_app_store', { ...data })
    return response
  },
  async getItems (context, { keys }) {
    return await Promise.all(
      [...keys].map(item =>
        get(`/interface/etcd/item/${item}`)
      )
    )
  },
  async created (context, { platform, id }) {
    return await capturedGet(`/${platform}/creative/${id}`)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
};
